module.exports = __webpack_public_path__ + "static/media/health-life-science-square.d72a9eba.jpg";